import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_01.png";
import Img_Two from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_02.png";
import Img_Three from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_03.png";
import Img_Four from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_04.png";
import Img_Five from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_05.png";
import Img_Six from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_06.png";
import Img_Seven from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_07.png";
import Img_Eight from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_08.png";
import Img_Nine from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_09.png";
import Img_Ten from "./../../../../sources/imgs/STEGHIDE/STEGHIDE_10.png";
import Img_Eleven from "../../../../sources/imgs/STEGHIDE/STEGHIDE_11.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function STEGHIDE (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> STEGHIDE.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Introducción a STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Steghide</span> es una <span className="span-white">herramienta</span> de <span className="span-pink">esteganografía</span> en <i className="span-white">línea de comandos</i> que permite <i className="span-pink">ocultar (embeber) archivos</i> dentro de archivos portadores de tipo <i className="span-blue">imagen</i> o <i className="span-blue">audio</i> sin que el portador cambie <i className="span-blue">visual</i> o <i className="span-blue">auditivamente</i> de <span className="span-white">forma apreciable</span>. A diferencia de simplemente <span className="span-pink">incrustar</span> datos dentro de un archivo, <span className="span-yellow">Steghide</span> aplica <span className="span-white">compresión</span> y <span className="span-white">cifrado</span> al contenido que se desea ocultar y lo inserta en los <span className="span-pink">bits menos sensibles</span> del archivo portador, por ejemplo en <i className="span-white">JPEG</i>, <i className="span-white">BMP</i>, <i className="span-white">WAV</i> o <i className="span-white">AU</i>, de forma que la presencia de datos ocultos <span className="span-pink">resulta difícil de percibir</span> a <span className="span-white">simple vista</span>.
            </p>

            <p>
                Dentro de la fase de <span className="span-pink">post-exploitation</span>, <span className="span-yellow">Steghide</span> se emplea como <span className="span-pink">técnica</span> para <i className="span-white">encubrir</i> y <i className="span-white">exfiltrar</i> información desde una <span className="span-white">máquina comprometida</span> hacia un destino controlado por el <span className="span-pink">evaluador</span> <i className="span-pink">(o por un atacante simulado)</i>, minimizando la probabilidad de detección por controles tradicionales que inspeccionan solo nombres de archivo o extensiones. También se utiliza en <span className="span-pink">ejercicios</span> como prueba de concepto para evaluar controles <i className="span-white">DLP</i>, <i className="span-white">IDS/IPS</i> y <i className="span-white">políticas de inspección de archivos</i>.
            </p>


            <p>
                <b className="span-white">
                    Usos habituales en pruebas de seguridad:
                </b>
            </p>

            <ul className="ol-code">
                    <li>
                        <p>
                            <span className="span-white">Prácticas</span> y <span className="span-white">ejercicios</span> de <span className="span-pink">esteganografía</span> controlados.
                        </p>
                    </li>

                    <li>
                        <p>
                            <span className="span-pink">Simulación</span> de <span className="span-white">exfiltración</span> de <span className="span-white">datos encubierta</span> durante <span className="span-white">pruebas de intrusión</span>.
                        </p>
                    </li>

                    <li>
                        <p>
                            <span className="span-white">Laboratorios forenses</span> para <span className="span-pink">validar</span> procedimientos de <i className="span-blue">detección</i> y <i className="span-blue">extracción</i> de <span className="span-white">datos ocultos</span>.
                        </p>
                    </li>
            </ul>

            <p>
                <b className="span-yellow">Nota: </b> El uso de <span className="span-pink">esteganografía</span> para <span className="span-white">fines maliciosos</span> es <i className="span-blue">ilegal</i> y <i className="span-blue">antiético</i>. Las pruebas descritas en este documento se realizan únicamente en <span className="span-white">entornos autorizados</span> y <span className="span-white">controlados</span> con <span className="span-pink">fines defensivos</span> y de <span className="span-pink">mejora de seguridad</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Formatos soportados con STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Steghide</span> trabaja típicamente con estos <span className="span-white">tipos de portadores (según versión/compilación)</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <b className="span-pink">Imágenes</b>: <i className="span-white">JPEG, BMP.</i>
                    </p>
                </li>

                <li>
                    <p>
                        <b className="span-pink">Audio</b>: <i className="span-white">WAV, AU.</i>
                    </p>
                </li>
            </ul>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Instalación de STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Kali Linux</i> suele incluir <i className="span-yellow">Steghide</i> en sus <span className="span-white">repositorios</span>.
            </p>

            <p>
                Puedes instalar <i className="span-yellow">Steghide</i> ejecutando los <span className="span-white">comandos</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt update"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install steghide -y"
            />

            <p>
                Tal como se <span className="span-pink">visualiza</span> a <span className="span-white">continuación</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando de instalacion de STEGHIDE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Vesión de STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si instalamos <i className="span-yellow">Steghide</i> de <span className="span-white">manera correcta</span>, podemos <span className="span-pink">ejecutar</span> el <span className="span-white">comando</span> siguiente:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "steghide --version"
            />

            <p>
                <span className="span-white">Ejemplo</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"2. Comando de visualización de versión de STEGHIDE."}
            />

            <p>
                <b className="span-yellow">Nota: </b>Este comando muestra la <span className="span-pink">versión</span> de <i className="span-yellow">Steghide</i> <span className="span-white">instalada</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Ayuda de STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si deseamos <span className="span-pink">visualizar</span> la <span className="span-white">documentación</span> de <i className="span-yellow">Steghide</i>, podemos <span className="span-pink">ejecutar</span> el <span className="span-white">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "steghide --help"
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando de visualización de documentación de STEGHIDE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Conceptos básicos de STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Steghide</i> opera con <span className="span-white">3 comandos principales</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-pink">embed</i> —&gt; <span className="span-white">embeber (ocultar) un archivo dentro de un portador.</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-pink">extract</i> —&gt; <span className="span-white">extraer el archivo oculto.</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-pink">info</i> —&gt; <span className="span-white">mostrar información sobre un portador (si contiene datos de <i className="span-yellow">Steghide</i>).</span>
                    </p>
                </li>
            </ul>

            <p>
                La <span className="span-white">sintaxis</span> general:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "steghide <comando> [opciones]"
            />

            <p>
                <b className="span-white">
                    Opciones frecuentes:
                </b>
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-white">-cf &lt;coverfile&gt;</i> : <span className="span-pink">archivo portador (cover file).</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-white">-ef &lt;embedfile&gt;</i> : <span className="span-pink">archivo a ocultar (embed file) — usado con embed.</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-white">-sf &lt;stegofile&gt;</i> : <span className="span-pink">archivo resultante (stego file) — opcional; si no se especifica, puede sobrescribir o pedir.</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-white">-xf &lt;outputfile&gt;</i> : <span className="span-pink">nombre del archivo extraído — usado con extract.</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-white">-p &lt;passphrase&gt;</i> : <span className="span-pink">pasar la contraseña en la línea (si se omite, te la pedirá interactivamente).</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-white">-z &lt;level&gt;</i> : <span className="span-pink">nivel de compresión (si está disponible).</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-white">-v</i> : <span className="span-pink">verbose (salida detallada).</span>
                    </p>
                </li>
            </ul>

            <p>
                <b className="span-yellow">Nota: </b> <span className="span-pink">NO</span> incluyas <i className="span-white">contraseñas</i> en <i className="span-white">scripts visibles</i> en <span className="span-pink">entornos inseguros</span>. Es mejor dejarlas <i className="span-blue">interactivas</i> o usar <i className="span-blue">mecanismos seguros</i> para su <span className="span-pink">manejo</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Embeber (ocultar) un archivo dentro de otro con STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si deseamos <span className="span-pink">ocultar</span> un <span className="span-white">archivo</span> dentro de <span className="span-white">otro</span>, debemos <span className="span-pink">ejecutar</span> un <span className="span-white">comando</span> tal como:
            </p>
            
            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide embed -cf <imagen-portadora> -ef <archivo-dentro> -sf <nueva-imagen-creada>
# te pedirá una passphrase (contraseña) y confirmación`}
            />

            <p>
                <span className="span-white">Ejemplo:</span>
            </p>

            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide embed -cf portada.jpg -ef secreto.txt -sf portada_stego.jpg`}
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"4. Comando para embeber archivo dentro de imagen con STEGHIDE."}
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-pink">-cf portada.jpg</i> : <span className="span-white">cover file (portador).</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-pink">-ef secreto.txt</i> : <span className="span-white">archivo que quieres ocultar.</span>
                    </p>
                </li>

                <li>
                    <p>
                        <i className="span-pink">-sf portada_stego.jpg</i> : <span className="span-white">archivo de salida que contendrá datos ocultos.</span>
                    </p>
                </li>
            </ul>

            <p>
                Si quieres <span className="span-pink">pasar</span> la <i className="span-blue">passphrase</i> en la <span className="span-white">línea</span> <i className="span-white">(menos seguro)</i>:
            </p>
            
            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide embed -cf portada.jpg -ef secreto.txt -sf portada_stego.jpg -p "MiContraseñaSegura"`}
            />

            <p>
                <span className="span-white">Realizando</span>:
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"5. Comando para embeber archivo con parametro de contraseña con STEGHIDE."}
            />

            <p>
                También puedes <span className="span-pink">activar</span> <span className="span-white">compresión (si tu build lo soporta)</span> con <i className="span-white">-z</i>:
            </p>

            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide embed -cf portada.jpg -ef secreto.txt -sf portada_stego.jpg -z 9`}
            />

            <p>
                <span className="span-white">Realizando</span>:
            </p>

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"6. Comando para embeber archivo con parametro de compresión con STEGHIDE."}
            />

            <p>
                <span className="span-yellow">Nota: </span><i className="span-white">(9 = máximo nivel de compresión, si está soportado.)</i>
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Visualizar información de archivo (ver si hay algo embebido) con STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Steghide</i> tambien permite <span className="span-pink">analizar archivos</span>, por si contienen <span className="span-white">datos ocultos</span>.
            </p>

            <p>
                Para ello, <span className="span-pink">utilizamos</span> un <span className="span-white">comando simple</span> como:
            </p>
            
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "steghide info <imagen-portadora>"
            />

            <p>
                <span className="span-white">Ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "steghide info portadora.jpg"
            />

            <p>
                <span className="span-white">Realizando</span>:
            </p>

            <Img
                img = {Img_Seven}
                alt = {"Imagen 7. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"7. Comando para visualizar información de archivo con STEGHIDE."}
            />

            <p>
                <b className="span-yellow">Nota: </b>La <span className="span-white">salida típica</span> indica si el <span className="span-white">archivo</span> contiene <span className="span-pink">datos embebidos</span> con <i className="span-yellow">Steghide</i>; también puede mostrar <span className="span-white">capacidad aproximada</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Extraer archivo oculto con STEGHIDE.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Por ultimo, y mas importante, para <span className="span-pink">extraer</span> los <span className="span-white">archivos ocultos</span> dentro, <span className="span-pink">ejecutamos</span> el <span className="span-white">comando</span>:
            </p>

            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide extract -sf <imagen-portadora> -xf <archivo-extraido>
# te pedirá la passphrase`}
            />

            <p>
                <span className="span-white">Ejemplo</span>:
            </p>

            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide extract -sf portada_stego.jpg -xf secreto_extraido.txt`}
            />

            <p>
                Deberia <span className="span-white">visualizarse</span> algo como:
            </p>

            <Img
                img = {Img_Eight}
                alt = {"Imagen 8. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"8. Comando para extraer archivos embebidos con STEGHIDE."}
            />

            <p>
                O pasando la <span className="span-blue">contraseña</span> en la <span className="span-white">línea</span> <i className="span-white">(no recomendado)</i>:
            </p>

            <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`steghide extract -sf portada_stego.jpg -xf secreto_extraido.txt -p "MiContraseñaSegura"`}
            />

            <p>
                <span className="span-white">Viendo</span>:
            </p>

            <Img
                img = {Img_Nine}
                alt = {"Imagen 9. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"9. Comando para extraer archivos embebidos con parametro de contraseña con STEGHIDE."}
            />

            <Img
                img = {Img_Ten}
                alt = {"Imagen 10. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"10. Visualización a simple vista de imagen con archivo embebido con STEGHIDE."}
            />

            <Img
                img = {Img_Eleven}
                alt = {"Imagen 11. STEGHIDE."}
                title = {"Descripcción de imagen."}
                text = {"11. Visualización final de archivo embebido con STEGHIDE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Consideraciones legales y éticas.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Ocultar</span> información con <i className="span-yellow">Steghide</i> puede ser <span className="span-white">perfectamente legítimo</span> <i className="span-white">(e.g., marcar marcas de agua digitales, proteger datos personales)</i>, pero también puede emplearse para <span className="span-pink">ocultar</span> <span className="span-white">actividades maliciosas</span>.
                    </p>
                </li>

                <li>
                    <p>
                        <span className="span-white">Antes</span> de <i className="span-blue">analizar</i> o <i className="span-blue">manipular</i> <span className="span-white">archivos ajenos</span>, asegúrate de tener <span className="span-pink">autorización</span>. En contextos <span className="span-yellow">forenses</span>, sigue las <span className="span-white">políticas</span> y <span className="span-white">procedimientos legales</span>.
                    </p>
                </li>
            </ul>
        </>
    );
}